/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'manageStoreList',params: {brandPath: this.$route.params.brandPath}} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">店舗詳細</p>
                </div>
            </div>
        </div>
        <StoreDetail/>
    </div>
</template>

<script>
    import StoreDetail from '@/app/components/StoreDetail.vue'
    export default {
        name: 'manageStoreDetail',
        components: {
            StoreDetail
        },
    }
</script>
